module.exports = __webpack_public_path__ + "img/people-03.f5f6d3b7.png";